export default "__VITE_ASSET__835a98cf__"